<template>
  <loan-status-alert-container owner-action-required :loan="loan">
    <template #borrower>
      <i18n path="components.loan.status.alerts.requested.borrower.contact_message" tag="p">
        <template #contact>
          <icon-button
            variant="ghost-secondary"
            size="inline"
            @click="$emit('jump', sections.contacts)"
            >{{ $t("components.loan.status.alerts.requested.borrower.contact") }}</icon-button
          >
        </template>
      </i18n>
    </template>

    <template #owner>
      <i18n path="components.loan.status.alerts.requested.owner.loan_request_message" tag="p">
        <template #borrower_name>
          <icon-button
            size="inline"
            variant="ghost-secondary"
            :onclick="() => $emit('jump', sections.contacts)"
            >{{ loan.borrower_user.name }}</icon-button
          >
        </template>
        <template #loanable>
          {{ loan.loanable.name }}
        </template>
      </i18n>
      <p v-if="canAcceptLoan">
        <template v-if="shownAsContact">
          {{ $t("components.loan.status.alerts.requested.owner.contact_visible") }}
        </template>
        <template v-else>
          {{ $t("components.loan.status.alerts.requested.owner.contact_hidden") }}
        </template>
      </p>

      <div class="mt-3 button-list">
        <markdown-editor
          id="message_for_borrower"
          v-model="comment"
          name="message_for_borrower"
          :placeholder="
            $t('components.loan.status.alerts.requested.owner.message_placeholder', {
              name: loan.borrower_user.name,
            })
          "
        >
        </markdown-editor>

        <icon-button
          v-if="canAcceptLoan"
          size="sm"
          variant="success"
          icon="check-circle"
          :onclick="acceptLoan"
          :disabled="acting"
        >
          {{ $t("components.loan.status.alerts.requested.owner.accept") }}
        </icon-button>

        <icon-button
          v-if="canRejectLoan"
          size="sm"
          icon="x-octagon"
          variant="outline-danger"
          :disabled="acting"
          :onclick="refuseLoan"
        >
          {{ $t("components.loan.status.alerts.requested.owner.reject") }}
        </icon-button>
      </div>
    </template>

    <template #admin>
      <p>{{ $t("components.loan.status.alerts.requested.admin.message") }}</p>
    </template>
  </loan-status-alert-container>
</template>

<script>
import LoanStatusAlertContainer from "@/components/Loan/Status/Alerts/LoanStatusAlertContainer.vue";
import IconButton from "@/components/shared/IconButton.vue";
import MarkdownEditor from "@/components/shared/MarkdownEditor.vue";
import { canAcceptLoan, canRejectLoan, isBorrower } from "@/helpers/permissions/loans";
import { sections } from "@/components/Loan/FullLoanSections";
import { acceptLoan, rejectLoan } from "@/requests/loanRequests";

export default {
  name: "LoanRequested",
  components: {
    MarkdownEditor,
    LoanStatusAlertContainer,
    IconButton,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      comment: null,
      acting: false,
      sections,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isBorrower() {
      return isBorrower(this.user, this.loan);
    },
    canAcceptLoan() {
      return canAcceptLoan(this.user, this.loan);
    },
    canRejectLoan() {
      return canRejectLoan(this.user, this.loan);
    },
    shownAsContact() {
      return (
        this.loan.loanable.merged_user_roles.filter(
          (r) => r.user_id === this.user.id && r.show_as_contact
        ).length > 0
      );
    },
  },
  methods: {
    async acceptLoan() {
      this.acting = true;
      try {
        const response = await acceptLoan(this.loan, {
          comment: this.comment,
        });
        if (response && response.data) {
          this.$emit("input", response.data);
        }
      } finally {
        this.acting = false;
      }
    },
    async refuseLoan() {
      this.acting = true;

      try {
        const response = await rejectLoan(this.loan.id, {
          comment: this.comment,
        });
        if (response && response.data) {
          this.$emit("input", response.data);
        }
      } finally {
        this.acting = false;
      }
    },
  },
};
</script>

<style lang="scss"></style>
